<template>
  <div class="space-y-2">
    <div class="flex justify-between text-sm text-gray-600">
      <span>Progression</span>
      <span>{{ percentage }}%</span>
    </div>
    <div class="h-3 bg-gray-200 rounded-full overflow-hidden shadow-inner">
      <div
        class="h-full transition-all duration-500 ease-out"
        :style="{ 
          width: `${percentage}%`, 
          backgroundColor: getProgressColor(percentage)
        }"
      ></div>
    </div>
    <div class="flex justify-between text-xs">
      <span 
        :class="{
          'font-bold text-green-600': percentage >= 100,
          'text-gray-500': percentage < 100
        }"
      >
        {{ total - remaining }}/{{ total }} plans financés
      </span>
      <span v-if="percentage >= 100" class="text-green-600 font-bold">
        Financement complet !
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  total: {
    type: Number,
    required: true
  },
  remaining: {
    type: Number,
    required: true
  },
  percentage: {
    type: Number,
    required: true
  }
});

/**
 * Retourne une couleur basée sur le pourcentage de progression
 * Rouge (0%) -> Orange (50%) -> Vert (100%)
 */
const getProgressColor = (percent) => {
  if (percent >= 100) return '#10b981'; // Vert à 100%
  
  // Couleurs intermédiaires basées sur le pourcentage
  if (percent < 25) {
    return '#ef4444'; // Rouge pour 0-25%
  } else if (percent < 50) {
    return '#f97316'; // Orange pour 25-50%
  } else if (percent < 75) {
    return '#f59e0b'; // Jaune pour 50-75%
  } else {
    return '#84cc16'; // Vert clair pour 75-100%
  }
};
</script> 